import { render } from "./PaginaAdmin.vue?vue&type=template&id=44ec8c22&scoped=true"
import script from "./PaginaAdmin.vue?vue&type=script&lang=js"
export * from "./PaginaAdmin.vue?vue&type=script&lang=js"

import "./PaginaAdmin.vue?vue&type=style&index=0&id=44ec8c22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ec8c22"]])

export default __exports__